<template>
  <booking-card :isLoading="isLoading">
    <template v-slot:title>
      <h5 class="text-color-kerry font-weight-bold mb-4">
        {{ $t("myBookingHistory") }}
      </h5>
    </template>
    <div v-if="bookingLists.length > 0">
      <div :key="index" v-for="(booking, index) in bookingLists" class="my-4">
        <p>{{ booking.bookingDateTime }}</p>
        <div
          :key="index"
          v-for="(bookDetail, index) in booking.data"
          class="booking-container"
        >
          <router-link
            :to="`/my-booking/details/${lang}?sessionId=${sessionId}&telephone=${params.telephone}&trackingNo=${bookDetail.trackingNo}`"
            class="
              header-container
              p-3
              d-flex
              justify-content-between
              align-items-center
              text-decoration-none
            "
          >
            <p class="mb-0 text-color-kerry font-weight-bold">
              {{ bookDetail.trackingNo }}
            </p>
            <font-awesome-icon class="text-color-kerry" icon="angle-right" />
          </router-link>
          <b-container class="p-3 m-0 mw-100">
            <b-row class="no-gutters">
              <b-col cols="4"> <span>ผู้รับ </span></b-col>
              <b-col cols="8"
                ><span>{{ bookDetail.recipientName }}</span>
              </b-col>
            </b-row>
            <b-row class="no-gutters">
              <b-col cols="4"> <span>เบอร์โทรศัพท์ </span></b-col>
              <b-col cols="8"
                ><span>{{ bookDetail.recipientTelephone }}</span>
              </b-col>
            </b-row>
            <b-row class="no-gutters">
              <b-col cols="4"> <span>ที่อยู่จัดส่ง </span></b-col>
              <b-col cols="8"
                ><span>{{ bookDetail.address }}</span>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="nodata-container p-3">
        <p class="text-center mb-0 text-color-kerry">{{ $t("noData") }}</p>
      </div>
    </div>
  </booking-card>
</template>

<script>
import BookingCard from '../../../components/booking-card/BookingCard.vue';
export default {
  components: { BookingCard },
  name:"MyBookingHistory",
  data: function(){
    return{
      lang:"",
      sessionId: "",
      brandId:1,
      params:{
        userGUID:"",
        telephone: "",
      },
      bookingLists:[],
      isLoading:true
    }
    },
  beforeCreate: async function () {
    if (this.$liff.isInClient()) {
      this.$liff
        .init({ liffId: this.$liff_Main_ID })
        .then(() => {
          this.$liff.getProfile().then(profile => {
            this.lineProfile = profile;
          });
        })
        .catch(error => {
          console.error("error", error);
        });
    }
  },
  created: async function () {
    const {telephone,sessionId} = this.$route.query
    this.lang = this.$route.params.lang ? this.$route.params.lang : "th"
    this.params.telephone = telephone
    this.sessionId = sessionId
    if(this.sessionId){
      await this.getUserGUID()
      await this.getBookingList()
    } else {
      this.$router.push('/session-expired')
    }
  },
  methods: {
    getUserGUID: async function(){
      const getUserUrl = `${this.$baseUrl}/kerryApi/user/${this.sessionId}`
      const {result,error} = await this.handlePromise(this.$axios.get(getUserUrl))
      if (error) {
        console.log(error)
        return
      }
      if(result.data.result === 1){
        this.params.userGUID = result.data.detail.userGUID
        if(!this.params.userGUID){
          this.$router.push('/session-expired')
        }else if (!result.data.detail.isLogin){
          const redirectUrl = encodeURIComponent(
            `/my-booking/${this.lang}?sessionId=${this.sessionId}&telephone=${this.params.telephone}`
          );
          this.$router.push(`/login?sessionId=${this.sessionId}&redirectUrl=${redirectUrl}`);
        }
      }
    },
    getBookingList: async function(){
      const getBookingListUrl = `${this.$baseUrl}/kerryapi/MyBooking`
      const {result,error} = await this.handlePromise(this.$axios.post(getBookingListUrl,this.params))
      if (error) {
        console.log(error)
        return
      }
      if(result.data.result == 1){
        this.bookingLists = result.data.detail
        this.isLoading = false
      }
    },
    handlePromise: function(promise) {
      return promise.then(data => {
        return {
          error:null,
          result: data
        }
      })
      .catch(err => {
        return {
          error: err
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-container {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.nodata-container {
  background-color: #ffffff;
  border-radius: 8px;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-container {
  border-bottom: 1px solid #bebebe;
  cursor: pointer;
}
</style>